import styled from 'styled-components';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  margin-top: 12px;
`;

export const ContainerChart = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${(props) => props.theme.color.sidebarBorder};
  background-color: white;
  border-radius: 4px;
  padding: 0 20px;
`;

export const ContainerHeader = styled.div`
  margin-bottom: 12px;
`;

export const Header = styled(TextLayoutComponent.Bold)`
  font-size: 16px;
  margin-bottom: 15px;
`;
